module.exports = __webpack_public_path__ + "assets/roboto-v30-latin_latin-ext-100.985a841110216240a35a8c4fc60584b3.woff";